import * as classnames from 'classnames/bind'
import * as React from 'react'
import BasicLayout from '../../layouts/BasicLayout'
import styles from './help-page.scss'


const cx = classnames.bind({...styles})


class HelpPage extends React.Component {
  public state = {
    qraftTermsActive: true,
    privacyTermsActive: false,
    userTermsActive: false,
    refundActive: false,
  }

  private ref: { [refName: string]: HTMLElement | null } = {
    qraftTerms: null,
    privacyTerms: null,
    userTerms: null,
    refund: null,
  }

  public scrollToAnchor = (anchorName: string) => {
    const anchorElement = this.ref[anchorName]
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: 'smooth' })
    }
    this.setState({
      qraftTermsActive: anchorName === 'qraftTerms' ? true : false,
      privacyTermsActive: anchorName === 'privacyTerms' ? true : false,
      userTermsActive: anchorName === 'userTerms' ? true : false,
      refundActive: anchorName === 'refund' ? true : false,
    })
  }


  public render() {
    return (
      <BasicLayout>
        {/* <!-- Start main --> */}
        <section className={cx('main')}>

          {/* <!-- Start page title --> */}
          <div className={cx('page-title', 'bgc--white')}>
            <div className={cx('container')}>
              <h1 className={cx('page-title__title', 'color--black')}>Qraft 服務</h1>
            </div>
          </div>
          {/* <!-- End page title --> */}

          {/* <!-- Start terms main --> */}
          <div className={cx('page-Terms__main')}>
            <div className={cx('container', 'g-pb-70')}>
              <div className={cx('row')}>
                <div className={cx('col-lg-6')}>
                  <div className={cx('text-center', 'g-rounded-5', 'g-brd-around', 'g-brd-gray-light-v4', 'g-overflow-hidden', 'u-shadow-v1-5--hover', 'g-transition-0_3', 'g-px-20', 'g-py-30')}>
                    <span className={cx('u-icon-v1', 'u-icon-size--xl', 'g-color-black', 'g-mb-10')}>
                      <div className={cx('icon', 'icon-messenger')} />
                    </span>
                    <h3 className={cx('h4', 'g-color-black', 'mb-2')}>FB 客服聯絡</h3>
                    <span className={cx('d-block', 'h5', 'g-color-black-opacity-0_7', 'mb-4')}> 在線客服直接聯繫 </span>
                    <a className={cx('btn', 'btn-md', 'g-color-white', 'g-font-weight-600', 'g-bg-primary', 'g-bg-primary--hover', 'g-rounded-25')} href="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2F234077063907224%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink" target="_blank">聯絡</a>
                  </div>
                </div>
                <div className={cx('col-lg-6')}>
                  <div className={cx('text-center', 'g-rounded-5', 'g-brd-around', 'g-brd-gray-light-v4', 'g-overflow-hidden', 'u-shadow-v1-5--hover', 'g-transition-0_3', 'g-px-20', 'g-py-30')}>
                    <span className={cx('u-icon-v1', 'u-icon-size--xl', 'g-color-black', 'g-mb-10')}>
                      <div className={cx('icon', 'icon-email')} />
                      </span>
                    <h3 className={cx('h4', 'g-color-black', 'mb-2')}>信件聯絡</h3>
                    <span className={cx('d-block', 'h5', 'g-color-black-opacity-0_7', 'mb-4')}>contact@qraft.app</span>
                    <a className={cx('btn', 'btn-md', 'g-color-white', 'g-font-weight-600', 'g-bg-primary', 'g-bg-primary--hover', 'g-rounded-25')} href="mailto:contact@qraft.app?subject=客服建議&body=非常感謝你的提問，我們會盡快解決你的問題">聯絡</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- End terms main --> */}

          {/* <!-- Icon Blocks --> */}
          <section className={cx('g-brd-y', 'g-brd-gray-light-v4', 'g-pos-rel', 'g-overflow-hidden')}>
            <div className={cx('container', 'g-pt-100', 'g-pb-50')}>
              <div className={cx('row', 'justify-content-between')}>
                <div className={cx('col-lg-4', 'g-mb-50')}>
                  {/* <!-- Heading --> */}
                  <div className={cx('text-center', 'text-lg-left', 'g-mb-60')}>
                    <div className={cx('d-inline-block', 'g-width-35', 'g-height-1', 'g-bg-primary', 'mb-3')} />
                    <h2 className={cx('g-color-black', 'g-font-weight-600', 'mb-5')}>常見講座問題</h2>
                  </div>
                  {/* <!-- End Heading --> */}
                </div>

                <div className={cx('col-lg-8')}>
                  {/* <!-- Icon Blocks --> */}
                  <div className={cx('row')}>
                    <div className={cx('col-sm-6', 'text-center', 'text-lg-left', 'g-mb-50')}>
                      {/* <!-- Icon Blocks --> */}
                      <span className={cx('d-inline-block', 'g-color-primary', 'g-font-size-30', 'g-rounded-5 mb-2')}>
                        <i className={cx('icon-education-087', 'u-line-icon-pro')} />
                      </span>
                      <h3 className={cx('h5', 'g-font-weight-600', 'mb-2')}>早鳥預購是什麼意思呢？</h3>
                      <p className={cx('g-color-gray-dark-v4', 'mb-0')}>早鳥預購都會有 <span className={cx('g-color-primary')}>7折以上的優惠</span> 若按下立即參與，就會變成線上講座的成員哦！<br />若人數未達講座最低門檻，Qraft 平台將會於預購結束後，退還全額講座費用</p>
                      {/* <!-- End Icon Blocks --> */}
                    </div>

                    <div className={cx('col-sm-6', 'text-center', 'text-lg-left', 'g-mb-50')}>
                      {/* <!-- Icon Blocks --> */}
                      <span className={cx('d-inline-block', 'g-color-primary', 'g-font-size-30', 'g-rounded-5 mb-2')}>
                        <i className={cx('icon-education-035', 'u-line-icon-pro')} />
                      </span>
                      <h3 className={cx('h5', 'g-font-weight-600', 'mb-2')}>可以問講者問題嗎？</h3>
                      <p className={cx('g-color-gray-dark-v4', 'mb-0')}>可以直接在每個知識內容的區塊按下「留言」，就能立即與講者互動，此外講師會在講座期間內(1個月)保證 <span className={cx('g-color-primary')}>72hr</span> 內回覆</p>
                      {/* <!-- End Icon Blocks --> */}
                    </div>

                    <div className={cx('col-sm-6', 'text-center', 'text-lg-left', 'g-mb-50')}>
                      {/* <!-- Icon Blocks --> */}
                      <span className={cx('d-inline-block', 'g-color-primary', 'g-font-size-30', 'g-rounded-5', 'mb-2')}>
                        <i className={cx('icon-education-141', 'u-line-icon-pro')} />
                      </span>
                      <h3 className={cx('h5', 'g-font-weight-600', 'mb-2')}>講座可以要求退費嗎？</h3>
                      <p className={cx('g-color-gray-dark-v4', 'mb-0')}>沒問題！Qraft 在開講後 7 天內，若無收聽講座者(除了試聽單元外)都可申請退款！，此外「正式開講」購買講座者：購買七日之內（含購買當日）認為不符合需求，且未收聽講座（除試聽單元外），可提出退費申請。</p>
                      {/* <!-- End Icon Blocks --> */}
                    </div>

                    <div className={cx('col-sm-6', 'text-center', 'text-lg-left', 'g-mb-50')}>
                      {/* <!-- Icon Blocks --> */}
                      <span className={cx('d-inline-block', 'g-color-primary', 'g-font-size-30', 'g-rounded-5 mb-2')}>
                        <i className={cx('icon-finance-256', 'u-line-icon-pro')} />
                      </span>
                      <h3 className={cx('h5', 'g-font-weight-600', 'mb-2')}>講座課程互動有時效性嗎？</h3>
                      <p className={cx('g-color-gray-dark-v4', 'mb-0')}>講座購買後將不限次數的發問。且將作結束後此我們提供歸檔服務，你隨時可聽到我們即時更新的講座內容。</p>
                      {/* <!-- End Icon Blocks --> */}
                    </div>
                  </div>
                  {/* <!-- End Icon Blocks --> */}
                </div>

              </div>

              
            </div>
          </section>
          {/* <!-- End Icon Blocks --> */}
        </section>
        {/* <!-- End main --> */}
      </BasicLayout>
    )
  }
}

export default HelpPage


// WEBPACK FOOTER //
// ./src/pages/HelpPage/index.tsx